/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileLite,
    CaseFileLiteFromJSON,
    CaseFileLiteFromJSONTyped,
    CaseFileLiteToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResponsiveFile
 */
export interface ResponsiveFile {
    /**
     * 
     * @type {string}
     * @memberof ResponsiveFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsiveFile
     */
    interrogatoryQueryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsiveFile
     */
    caseFileId: string;
    /**
     * 
     * @type {CaseFileLite}
     * @memberof ResponsiveFile
     */
    caseFile?: CaseFileLite;
    /**
     * 
     * @type {number}
     * @memberof ResponsiveFile
     */
    interrogatoryId: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsiveFile
     */
    documentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsiveFile
     */
    isWithheld: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsiveFile
     */
    isArchived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsiveFile
     */
    isVerified: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ResponsiveFile
     */
    creationDate: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof ResponsiveFile
     */
    pages?: Array<number> | null;
}

export function ResponsiveFileFromJSON(json: any): ResponsiveFile {
    return ResponsiveFileFromJSONTyped(json, false);
}

export function ResponsiveFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsiveFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'interrogatoryQueryId': !exists(json, 'interrogatoryQueryId') ? undefined : json['interrogatoryQueryId'],
        'caseFileId': json['caseFileId'],
        'caseFile': !exists(json, 'caseFile') ? undefined : CaseFileLiteFromJSON(json['caseFile']),
        'interrogatoryId': json['interrogatoryId'],
        'documentId': json['documentId'],
        'isWithheld': json['isWithheld'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'isVerified': json['isVerified'],
        'creationDate': (new Date(json['creationDate'])),
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
    };
}

export function ResponsiveFileToJSON(value?: ResponsiveFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'interrogatoryQueryId': value.interrogatoryQueryId,
        'caseFileId': value.caseFileId,
        'caseFile': CaseFileLiteToJSON(value.caseFile),
        'interrogatoryId': value.interrogatoryId,
        'documentId': value.documentId,
        'isWithheld': value.isWithheld,
        'isArchived': value.isArchived,
        'isVerified': value.isVerified,
        'creationDate': (value.creationDate.toISOString()),
        'pages': value.pages,
    };
}


